import { ADD_TO_QUEUE, REMOVE_FROM_QUEUE, CLEAR_QUEUE } from 'actions/types';

export default function(state = null, action) {
  switch (action.type) {
    case ADD_TO_QUEUE:
    case REMOVE_FROM_QUEUE:
      return { ...state, ...action.payload };
    case CLEAR_QUEUE:
      return null;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/uploads.js